<section>
  <article class="container">
    <div class="row py-5">
      <div class="col-12 section-app text-center" *ngIf="!!promocion">
        <!-- <span>Hónranos con tu presencia en</span> -->
        <h3 class="mt-3">{{ promocion.nombre }}</h3>
        <div class="bottom-line"></div>
      </div>
    </div>
  </article>
</section>

<section>
  <article class="container">
    <div class="row ">
      <div class="col-12 col-md-7">
        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <a href="{{ carrusel.url }}" class="carousel-item"
              *ngFor="let carrusel of imagenes_carrusel; let index = index"
              [class]="index == 0 ? 'carousel-item active' : 'carousel-item'">
              <img src="{{ carrusel.img }}" class="d-block w-100" alt="{{ carrusel }}" />
            </a>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <div class="col-12 col-md-5" *ngIf="!!promocion">
        <h3 class="py-2">{{ promocion.nombre }}</h3>
        <p class="mb-1" style="word-wrap: break-word" *ngFor="let item of descriptionToArray(promocion.descripcion)">
          {{ item }}
        </p>
        <div class="mb-5"></div>
        <a href="https://api.whatsapp.com/send?phone=+52{{teams[0]?.whatsapp}}&text=%F0%9F%98%80%20Hola,%20quiero%20mas%20informaci%C3%B3n{{
            getName(' sobre la promoción: ' + promocion.nombre)
          }}" target="_blank" class="btn-tadeo2 mt-5">
          <i class="fa-brands fa-whatsapp pe-2"></i>
          Envíar whatsapp
        </a>
      </div>
    </div>
  </article>
</section>

<section>
  <article class="container-fluid py-5">
    <div class="row">
      <div class="col-12 p-0" *ngIf="!!map_url">
        <iframe [src]="map_url" height="450" style="border: 0" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade" class="w-100"></iframe>
      </div>
    </div>
  </article>
</section>
